module.exports = __webpack_public_path__ + "static/media/back_arrow.5b94aeb9.svg";